import { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    MenuItem,
    Button,
    Stack,
    Chip,
    Box,
    Checkbox,
    FormControlLabel,
    Radio,
    RadioGroup,
    Typography,
} from "@mui/material";

export default function SauvegardeModal({
    open,
    onClose,
    onSave,
    initialData,
    clients,
    backupTypes = [],
    loading = false,
}) {
    const [form, setForm] = useState({
        name: "",
        clientId: "",
        backupTypeId: "",
        frequencyType: null,
        expectedEmailCount: 1,
        expectedDays: [],
        windowStart: "00:00",
        windowEnd: "23:59",
        expectedSenders: [],
        subjectPattern: "",
        successKeywords: [],
        failureKeywords: [],
        alertKeywords: [],
    });

    const [senderInput, setSenderInput] = useState("");
    const [successKeywordInput, setSuccessKeywordInput] = useState("");
    const [failureKeywordInput, setFailureKeywordInput] = useState("");
    const [alertKeywordInput, setAlertKeywordInput] = useState("");
    const days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
    const daysLabels = {monday : "Lundi",
         tuesday: "Mardi", 
         wednesday: "Mercredi", 
         thursday: "Jeudi", 
         friday : "Vendredi", 
         saturday : "Samedi", 
         sunday: "Dimanche"};

    useEffect(() => {
        if (initialData) {
            setForm({
                name: initialData.name || "",
                clientId: initialData.clientId || "",
                backupTypeId: initialData.backupTypeId || "",
                frequencyType: initialData.frequencyType || null,
                expectedEmailCount: initialData.expectedEmailCount || 1,
                expectedDays: initialData.expectedDays || [],
                windowStart: initialData.windowStart || "00:00",
                windowEnd: initialData.windowEnd || "23:59",
                expectedSenders: initialData.expectedSenders || [],
                subjectPattern: initialData.subjectPattern || "",
                successKeywords: initialData.successKeywords || [],
                failureKeywords: initialData.failureKeywords || [],
                alertKeywords: initialData.alertKeywords || [],
            });
        } else {
            setForm({
                name: "",
                clientId: "",
                backupTypeId: "",
                frequencyType: null,
                expectedEmailCount: 1,
                expectedDays: [],
                windowStart: "00:00",
                windowEnd: "23:59",
                expectedSenders: [],
                subjectPattern: "",
                successKeywords: [],
                failureKeywords: [],
                alertKeywords: [],
            });
        }
        setSenderInput("");
        setSuccessKeywordInput("");
        setFailureKeywordInput("");
        setAlertKeywordInput("");
    }, [initialData, open]);

    const toggleDay = (day) => {
  if (form.expectedDays.includes(day)) {
    handleChange(
      "expectedDays",
      form.expectedDays.filter((d) => d !== day)
    );
  } else {
    handleChange("expectedDays", [...form.expectedDays, day]);
  }
};

    const mailFrequencies = () => {
  if (form.frequencyType === "daily") {
    return (
      <>
        <TextField
            label="Nombre de mails"
            value={form.expectedEmailCount}
            onChange={(e) => handleChange("expectedEmailCount", e.target.value)}
            InputLabelProps={{ shrink: true }}
        />
     <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center">
          <TextField
            label="Début fenêtre (HH:mm)"
            type="time"
            value={form.windowStart}
            onChange={(e) => handleChange("windowStart", e.target.value)}
            inputProps={{ step: 300 }}
            InputLabelProps={{ shrink: true }}
            />
          <TextField
            label="Fin fenêtre (HH:mm)"
            type="time"
            value={form.windowEnd}
            onChange={(e) => handleChange("windowEnd", e.target.value)}
            inputProps={{ step: 300 }}
            InputLabelProps={{ shrink: true }}
            />
            </Stack>
      </>
    );
  } else if (form.frequencyType === "weekly") {
    return (
      <>
        <TextField
            label="Nombre de mails"
            value={form.expectedEmailCount}
            onChange={(e) => handleChange("expectedEmailCount", e.target.value)}
            InputLabelProps={{ shrink: true }}
        />
               <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center">
          <TextField
            label="Début fenêtre (HH:mm)"
            type="time"
            value={form.windowStart}
            onChange={(e) => handleChange("windowStart", e.target.value)}
            inputProps={{ step: 300 }}
            InputLabelProps={{ shrink: true }}
            />
          <TextField
            label="Fin fenêtre (HH:mm)"
            type="time"
            value={form.windowEnd}
            onChange={(e) => handleChange("windowEnd", e.target.value)}
            inputProps={{ step: 300 }}
            InputLabelProps={{ shrink: true }}
            />
            </Stack>
            <Stack direction="row">
            {days.map((day) => (
                <FormControlLabel      key={day}    label={daysLabels[day]} control={<Checkbox
               
                    checked={form.expectedDays.includes(day)}
                    onChange={() => toggleDay(day)}
                    />}
                 
                  />
                    ))}
                    </Stack>
      </>
    );
  } else {
    return false;
  }
};

    const handleChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    const handleBackupTypeChange = (typeId) => {
        const selectedType = backupTypes.find((t) => String(t.id) === String(typeId));
        setForm((prev) => ({
            ...prev,
            backupTypeId: typeId,
            subjectPattern: selectedType?.subjectPattern || prev.subjectPattern,
            successKeywords: selectedType?.successKeywords?.length ? selectedType.successKeywords : prev.successKeywords,
            failureKeywords: selectedType?.failureKeywords?.length ? selectedType.failureKeywords : prev.failureKeywords,
            alertKeywords: selectedType?.alertKeywords?.length ? selectedType.alertKeywords : prev.alertKeywords,
        }));
    };

    const addSender = () => {
        if (senderInput.trim() && !form.expectedSenders.includes(senderInput)) {
            setForm((prev) => ({
                ...prev,
                expectedSenders: [...prev.expectedSenders, senderInput],
            }));
            setSenderInput("");
        }
    };

    const removeSender = (email) => {
        setForm((prev) => ({
            ...prev,
            expectedSenders: prev.expectedSenders.filter((s) => s !== email),
        }));
    };

    const addKeyword = (type) => {
        const input =
            type === "success"
                ? successKeywordInput
                : type === "failure"
                  ? failureKeywordInput
                  : alertKeywordInput;

        if (input.trim()) {
            const field =
                type === "success"
                    ? "successKeywords"
                    : type === "failure"
                      ? "failureKeywords"
                      : "alertKeywords";

            setForm((prev) => ({
                ...prev,
                [field]: [...(prev[field] || []), input],
            }));

            if (type === "success") setSuccessKeywordInput("");
            else if (type === "failure") setFailureKeywordInput("");
            else setAlertKeywordInput("");
        }
    };

    const removeKeyword = (type, keyword) => {
        const field =
            type === "success"
                ? "successKeywords"
                : type === "failure"
                  ? "failureKeywords"
                  : "alertKeywords";

        setForm((prev) => ({
            ...prev,
            [field]: prev[field].filter((k) => k !== keyword),
        }));
    };

    const handleSave = () => {
        if (!form.name || !form.clientId) {
            alert("Veuillez remplir le nom et le client");
            return;
        }

        // Inclure le sender en cours de saisie s'il n'a pas été ajouté via le bouton
        let finalSenders = form.expectedSenders;
        if (senderInput.trim() && !finalSenders.includes(senderInput.trim())) {
            finalSenders = [...finalSenders, senderInput.trim()];
        }

        // Inclure les keywords en cours de saisie
        let finalSuccessKeywords = form.successKeywords || [];
        if (successKeywordInput.trim() && !finalSuccessKeywords.includes(successKeywordInput.trim())) {
            finalSuccessKeywords = [...finalSuccessKeywords, successKeywordInput.trim()];
        }
        let finalFailureKeywords = form.failureKeywords || [];
        if (failureKeywordInput.trim() && !finalFailureKeywords.includes(failureKeywordInput.trim())) {
            finalFailureKeywords = [...finalFailureKeywords, failureKeywordInput.trim()];
        }
        let finalAlertKeywords = form.alertKeywords || [];
        if (alertKeywordInput.trim() && !finalAlertKeywords.includes(alertKeywordInput.trim())) {
            finalAlertKeywords = [...finalAlertKeywords, alertKeywordInput.trim()];
        }

        onSave({
            ...form,
            backupTypeId: form.backupTypeId || null,
            expectedSenders: finalSenders,
            successKeywords: finalSuccessKeywords,
            failureKeywords: finalFailureKeywords,
            alertKeywords: finalAlertKeywords,
        });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle sx={{ pb: 2 }}>
                {initialData
                    ? "Modifier la sauvegarde"
                    : "Ajouter une sauvegarde"}
            </DialogTitle>
            <DialogContent sx={{ pt: 3, pb: 2 }}>
                <Stack spacing={2}>
                    {/* Ligne 1: Nom, Client */}
                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mt: 0.5 }}>
                        <TextField
                            fullWidth
                            label="Nom de la sauvegarde"
                            required
                            value={form.name}
                            onChange={(e) =>
                                handleChange("name", e.target.value)
                            }
                            placeholder="ex: Backup Daily SQL"
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            fullWidth
                            select
                            label="Client"
                            required
                            value={form.clientId}
                            onChange={(e) =>
                                handleChange("clientId", e.target.value)
                            }
                            InputLabelProps={{ shrink: true }}
                        >
                            <MenuItem value="">Sélectionner un client</MenuItem>
                            {clients.map((c) => (
                                <MenuItem key={c.id} value={c.id}>
                                    {c.nom || c.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Stack>

                    {/* Type de sauvegarde */}
                    <TextField
                        fullWidth
                        select
                        label="Type de sauvegarde"
                        value={form.backupTypeId}
                        onChange={(e) => handleBackupTypeChange(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        helperText={form.backupTypeId ? "Le pattern et les mots-clés ont été pré-remplis depuis le type sélectionné." : "Optionnel — pré-remplit automatiquement le pattern et les mots-clés."}
                    >
                        <MenuItem value="">Aucun type spécifique</MenuItem>
                        {backupTypes.map((t) => (
                            <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>
                        ))}
                    </TextField>

                    {/* Ligne 2: Emails attendus && fenêtre de vérification */}

                    <RadioGroup row
                        value={form.frequencyType}
                        onChange={(e) =>
                            handleChange("frequencyType", e.target.value)
                        }
                    >
                        <FormControlLabel
                            value="daily"
                            control={<Radio />}
                            label="Par jour"
                        />
                        <FormControlLabel
                            value="weekly"
                            control={<Radio />}
                            label="Par semaine"
                        />
                    </RadioGroup>
                    {mailFrequencies()}

                    {/* Pattern de sujet */}
                    <TextField
                        fullWidth
                        label="Pattern de sujet (regex optionnel)"
                        value={form.subjectPattern}
                        onChange={(e) =>
                            handleChange("subjectPattern", e.target.value)
                        }
                        placeholder="ex: ^Backup.*SQL$"
                        multiline
                        rows={2}
                    />

                    {/* Expéditeurs */}
                    <Box>
                        <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Ajouter un expéditeur"
                                value={senderInput}
                                onChange={(e) => setSenderInput(e.target.value)}
                                onKeyPress={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        addSender();
                                    }
                                }}
                                placeholder="backup@system.com"
                            />
                            <Button onClick={addSender} variant="outlined">
                                Ajouter
                            </Button>
                        </Stack>
                        <Stack
                            direction="row"
                            spacing={1}
                            flexWrap="wrap"
                            useFlexGap
                        >
                            {form.expectedSenders.map((sender) => (
                                <Chip
                                    key={sender}
                                    label={sender}
                                    onDelete={() => removeSender(sender)}
                                />
                            ))}
                        </Stack>
                    </Box>

                    {/* Keywords - Success */}
                    <Box>
                        <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Keyword de succès"
                                value={successKeywordInput}
                                onChange={(e) =>
                                    setSuccessKeywordInput(e.target.value)
                                }
                                onKeyPress={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        addKeyword("success");
                                    }
                                }}
                                placeholder="ex: Success, Completed"
                            />
                            <Button
                                onClick={() => addKeyword("success")}
                                variant="outlined"
                                color="success"
                            >
                                Ajouter
                            </Button>
                        </Stack>
                        <Stack
                            direction="row"
                            spacing={1}
                            flexWrap="wrap"
                            useFlexGap
                        >
                            {form.successKeywords?.map((kw) => (
                                <Chip
                                    key={kw}
                                    label={kw}
                                    color="success"
                                    variant="outlined"
                                    onDelete={() =>
                                        removeKeyword("success", kw)
                                    }
                                />
                            ))}
                        </Stack>
                    </Box>

                    {/* Keywords - Failure */}
                    <Box>
                        <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Keyword d'erreur"
                                value={failureKeywordInput}
                                onChange={(e) =>
                                    setFailureKeywordInput(e.target.value)
                                }
                                onKeyPress={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        addKeyword("failure");
                                    }
                                }}
                                placeholder="ex: Failed, Error"
                            />
                            <Button
                                onClick={() => addKeyword("failure")}
                                variant="outlined"
                                color="error"
                            >
                                Ajouter
                            </Button>
                        </Stack>
                        <Stack
                            direction="row"
                            spacing={1}
                            flexWrap="wrap"
                            useFlexGap
                        >
                            {form.failureKeywords?.map((kw) => (
                                <Chip
                                    key={kw}
                                    label={kw}
                                    color="error"
                                    variant="outlined"
                                    onDelete={() =>
                                        removeKeyword("failure", kw)
                                    }
                                />
                            ))}
                        </Stack>
                    </Box>

                    {/* Keywords - Alert */}
                    <Box>
                        <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Keyword d'alerte"
                                value={alertKeywordInput}
                                onChange={(e) =>
                                    setAlertKeywordInput(e.target.value)
                                }
                                onKeyPress={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        addKeyword("alert");
                                    }
                                }}
                                placeholder="ex: Warning, Alert"
                            />
                            <Button
                                onClick={() => addKeyword("alert")}
                                variant="outlined"
                                color="warning"
                            >
                                Ajouter
                            </Button>
                        </Stack>
                        <Stack
                            direction="row"
                            spacing={1}
                            flexWrap="wrap"
                            useFlexGap
                        >
                            {form.alertKeywords?.map((kw) => (
                                <Chip
                                    key={kw}
                                    label={kw}
                                    color="warning"
                                    variant="outlined"
                                    onDelete={() => removeKeyword("alert", kw)}
                                />
                            ))}
                        </Stack>
                    </Box>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuler</Button>
                <Button
                    onClick={handleSave}
                    variant="contained"
                    disabled={loading}
                >
                    {initialData ? "Mettre à jour" : "Créer"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
